//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapState, mapActions } from "vuex";
import router from "../../router";
import orderItems from "./OrderItems";
import logger from "@/utils/logger";
import lazyLoadSelect from "@/components/LazyLoadSelect";

export default {
  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 15, // current rows per page being displayed
        sortBy: "orderNumber",
        descending: true,
        rowsNumber: 0
      },
      unfilteredOrders: [],
      orders: [],
      orderOptions: [
        { value: 200, name: this.$t("order.status-200") },
        { value: 300, name: this.$t("order.status-300") },
        { value: 400, name: this.$t("order.status-400") },
        { value: 500, name: this.$t("order.status-500") },
        { value: 600, name: this.$t("order.status-600") },
        { value: 700, name: this.$t("order.status-700") },
      ],
      orderStatuses: [],
      isLoading: false,
      isInitializing: false,
      filter: "",
      timerId: 0,
      customers: [],
      departmentSelected: [],
      projectId: "",
      title: this.$t("headers.salesOrder"),
      orderId: 0,
      dense: true,
      componentKey: 0,
      nodatalabel: "",
      visibleColumns: [ // add to data
        "orderNumber",
        "customerNumber",
        "customerName",
        "ourReference",
        "orderDate",
        "deliveryDate",
        "deliveryTerms",
        "canDeliver",
        "urgent",
        "departmentId",
        "projectName",
      ],
      columns: [
        {
          name: "orderNumber",
          align: "left",
          label: this.$t("order.orderNo"),
          style: "width: 200px",
          field: "orderNumber",
          sortable: true,
        },
        {
          name: "customerNumber",
          align: "left",
          label: this.$t("order.customerNumber"),
          field: "customerNumber",
          sortable: true,
        },
        {
          name: "customerName",
          align: "left",
          label: this.$t("order.customerName"),
          field: "customerName",
          sortable: true,
        },
        {
          name: "ourReference",
          align: "left",
          label: this.$t("order.ourReference"),
          field: "ourReference",
          sortable: true,
        },
        {
          name: "orderDate",
          align: "left",
          label: this.$t("order.orderDate"),
          field: "orderDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "deliveryDate",
          align: "left",
          label: this.$t("order.deliveryDate"),
          field: "deliveryDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "deliveryTerms",
          align: "left",
          label: this.$t("order.deliveryTerms"),
          field: "deliveryTerms",
          sortable: true,
        },
        {
          name: "canDeliver",
          align: "left",
          label: "Kan leveres",
          field: "canDeliver",
          format: (val) => this.$t("common." + val),
          sortable: true,
        },
        {
          name: "urgent",
          align: "center",
          label: "Haster",
          style: "color: red; font-size:medium; font-weight: bold",
          field: "urgent",
          sortable: true,
        },
        {
          name: "departmentName",
          align: "left",
          label: "Avdeling",
          field: "departmentName",
          sortable: true,
        },
        {
          name: "projectName",
          align: "left",
          label: "Prosjekt",
          field: "projectName",
          sortable: true,
        },
        {
          name: "customerOrderStatusId",
          align: "left",
          label: this.$t("order.customerOrderStatusId"),
          field: "customerOrderStatusId",
          format: (val) => this.$t("order.status-" + val),
          sortable: true,
        },
      ],
      numberOfSelectedOrderStatusesThatAreDisplayed: 0,
      countOfOrderStatusChars: 0,
      displayedOrderStatuses: [],

      numberOfSelectedDepartmentsThatAreDisplayed: 0,
      countOfDepartmentChars: 0,
      displayedDepartments: [],

      numberOfSelectedProjectsThatAreDisplayed: 0,
      countOfProjectChars: 0,
      displayedProjects: [],
    };
  },

  components: {
    orderItems,
    lazyLoadSelect
  },

  async created() {
    this.initVisibleColumns();
  },

  async mounted() {
    // Restoring saved filters mutates orderStatuses/departmentSelected, which fires their
    // watchers and would each schedule a redundant refresh on top of the initial load below.
    // Suppress that during init and do a single fetch once the watchers have flushed.
    this.isInitializing = true;
    this.initVisibleOrderStatuses();
    this.initVisibleSelectedDepartments();
    await this.$nextTick();
    this.isInitializing = false;
    await this.refresh();
  },
  computed: {
    ...mapState("main", ["departments", "projects"]),

    orderStatusDisplaySelected() {
      let result = "";

      for (let i = 0; i < this.numberOfSelectedOrderStatusesThatAreDisplayed; i++) {

        const orderStatusString = "order.status-" + this.orderStatuses[i];

        if (!this.$t(orderStatusString)) continue;
        result += this.$t(orderStatusString) + ", ";
      }

      result = result.slice(0, -2);

      if (this.countOfOrderStatusChars > 100) {
        result += "...";
      }

      return result;
    },

    departmentDisplaySelected() {
      let result = "";

      for (let i = 0; i < this.numberOfSelectedDepartmentsThatAreDisplayed; i++) {
        if (!this.departmentSelected[i]?.name) continue;
        result += this.departmentSelected[i].name + ", ";
      }

      result = result.slice(0, -2);

      if (this.countOfDepartmentChars > 20) {
        result += "...";
      }

      return result;
    },

  },

  watch: {
    async orderStatuses(newValue, oldValue) {
      if (newValue != oldValue && !this.isInitializing) {
        const notif = this.$q.notify({
          type: "ongoing",
          message: "Lagrer filter...",
        });
        await setTimeout(() => {
          notif();
        }, 1500);
        clearTimeout(this.timerId);
        this.timerId = setTimeout(this.filterStatuses, 2000);
      }

      let countOfChars = 0;
      for (let i = 0; i < this.orderStatuses.length; i++) {
        const orderValue = this.orderStatuses[i];
        const orderStatusString = "order.status-" + orderValue;

        countOfChars += this.$t(orderStatusString).length;
      }
      this.countOfOrderStatusChars = countOfChars;

      let visibleCount = 0;
      let runningLength = 0;
      for (const orderStatus of this.orderStatuses) {
        const orderStatusName = "order.status-" + orderStatus

        if (!this.$t(orderStatusName)) continue;
        if (runningLength + this.$t(orderStatusName).length > 100) break;
        runningLength += this.$t(orderStatusName).length;
        visibleCount++;
      }
      this.numberOfSelectedOrderStatusesThatAreDisplayed = visibleCount;
    },

    async departmentSelected(newValue, oldValue) {
      if (newValue != oldValue && !this.isInitializing) {
        const notif = this.$q.notify({
          type: "ongoing",
          message: "Lagrer filter...",
        });
        await setTimeout(() => {
          notif();
        }, 1500);
        clearTimeout(this.timerId);
        this.timerId = setTimeout(this.filterDepartmens, 2000);
        // Save the updated value to the cookie
      }

      let countOfChars = 0;
      for (let i = 0; i < this.departmentSelected.length; i++) {
        countOfChars += this.departmentSelected[i].name.length;
      }
      this.countOfDepartmentChars = countOfChars;

      let visibleCount = 0;
      let runningLength = 0;
      for (const department of this.departmentSelected) {
        if (!department.name) continue;
        if (runningLength + department.name.length > 20) break;
        runningLength += department.name.length;
        visibleCount++;
      }
      this.numberOfSelectedDepartmentsThatAreDisplayed = visibleCount;
    },

    async filter(newValue, oldValue) {
      if (newValue != oldValue) {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(this.runFilter, 2000);
      }
    },


  },
  methods: {
    async GetUniOrders() {
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Henter fra UNI",
      });
      await this.getSyncOrders();

      await this.refresh();
      notif();


    },

    enterCheck(event) {
      if (event.key === 'Enter' && this.filter != "") {
        if (this.orders.length == 1) {
          this.openOrder(this.orders[0].id);
        }
      }
    },

    onVisibleColumnsChange() {
      if (this.isRecevingMode)
        this.$cookies.set(
          "customerOrderRecieveColumns",
          this.visibleColumns.join(","),
          "1Y"
        );
      else
        this.$cookies.set(
          "customerOrderColumns",
          this.visibleColumns.join(","),
          "1Y"
        );
    },

    initVisibleColumns() {
      var cookieColums = this.$cookies.get("customerOrderColumns");
      if (this.isRecevingMode)
        cookieColums = this.$cookies.get("customerOrderRecieveColumns");

      if (cookieColums) {
        var columns = [];
        cookieColums.split(",").forEach(function (col) {
          columns.push(col);
        });
        this.visibleColumns = columns;
      }
    },

    initVisibleOrderStatuses() {
      var cookieStatus = this.$cookies.get("OrderStatusFiler");
      if (cookieStatus) {
        var columns = [];
        cookieStatus.split(",").forEach(function (col) {
          columns.push(Number(col));
        });

        this.orderStatuses = columns;
      }
    },

    initVisibleSelectedDepartments() {
      const cookieValue = this.$cookies.get("selectedDepartments");
      if (cookieValue) {
        try {
          this.departmentSelected = JSON.parse(cookieValue); // Set the initial value from the cookie
          logger.log(this.departmentSelected[0]);
        }
        catch (error) {
          //ignore      
        }

      }
    },

    filterStatuses() {

      this.refresh();
      this.$cookies.set("OrderStatusFiler", this.orderStatuses.join(","), "1Y");
    },

    filterDepartmens(dep) {
      this.refresh();

      try {
        this.$cookies.set("selectedDepartments", JSON.stringify(dep));
      }
      catch (error) {
        //ignore      
      }
    },

    runFilter() {
      this.refresh();
    },

    openOrder(orderId) {
      router.push({ name: "Order", params: { id: orderId } });
    },

    async refresh() {
      this.isLoading = true;

      var dep = [];
      this.departmentSelected.forEach((element) => {
        dep.push(parseInt(element.departmentNumber));
      });

      logger.log("projectId:" + this.projectId);


      this.orders = [];
      this.unfilteredOrders = [];

      if (dep.length == 0 && (this.projectId == undefined || this.projectId == '') && this.orderStatuses.length == 0 && this.filter == "") {
        this.nodatalabel = "Ingen ordre å vise. Velg avdeling, prosjekt, status eller søk for å vise ordre.";
        this.isLoading = false;
        return;
      }

      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      const payload = {
        pageNumber: this.pagination.page,
        pageSize: this.pagination.rowsPerPage,
        filter: this.filter,
        orderStatuses: this.orderStatuses,
        dep: dep,
        proj: this.projectId,
        sortBy: this.pagination.sortBy,
        sortDescending: this.pagination.descending
      };

      try {
        const data = await this.getOrdersByStatuses(payload);
        this.unfilteredOrders = data.items;
        this.orders = this.unfilteredOrders;
        this.pagination.rowsNumber = data.totalCount;
      } catch (error) {
        console.error("Error fetching orders:", error);
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorFetchingData")
        });
      }

      setTimeout(() => {
        notif();
      }, 500);

      this.isLoading = false;
    },

    projectLabel(project) {
      if (!project) return ''
      return `${project.projectNumber}: ${project.name}`
    },

    async fetchProjects({ pageNumber, pageSize, searchQuery }) {
      logger.log("fetchProjects: " + pageNumber + " pagesize: " + pageSize + " searchquery: " + searchQuery)

      if (!searchQuery) {
        return { items: this.projects, totalPages: pageNumber }
      }

      const filteredProjects = this.projects.filter((item) => {
        return item.name.toLowerCase().includes(searchQuery.toLowerCase())
      })

      return { items: filteredProjects, totalPages: pageNumber }
    },

    async fetchProject(projectId) {
      return this.projects.filter(p => p.id == projectId);
    },

    async projectValueChanged() {
      logger.log("projectId: " + this.projectId)
      this.refresh();
    },

    async refreshOrder(data) {

      var visible = this.orderStatuses.find(
        (x) => x == data.customerOrderStatusId
      );
      if (visible) {
        for (var j = 0; j < this.unfilteredOrders.length; j++) {
          if (this.unfilteredOrders[j].id == data.id) {
            this.unfilteredOrders[j] = data;
            break;
          }
        }
        for (var i = 0; i < this.orders.length; i++) {
          if (this.orders[i].id == data.id) {
            this.orders[i] = data;
            break;
          }
        }
      } else {
        this.refresh();
      }
    },

    onRequest(params) {
      if (this.isLoading) return;
      Object.assign(this.pagination, params.pagination);
      this.refresh();
    },

    ...mapActions("main", ["getOrdersByStatuses", "getSyncOrders"]),
  },
};
